module.exports = __webpack_public_path__ + "img/100_Kevin.6d10ef3a.png";